<template>
  <nav class="pb-3" aria-label="Breadcrumb">
    <ol class="flex space-x-1 truncate text-xs md:space-x-4 md:text-sm">
      <li>
        <div>
          <router-link to="/" class="text-gray-400 hover:text-gray-400">
            <span v-html="$icons.home"></span>

            <span class="sr-only">Home</span>
          </router-link>
        </div>
      </li>
      <li v-for="(item, i) in breadcrumb" :key="i">
        <div class="flex items-center">
          <span class="text-gray-400" v-html="$icons.chevron_right"></span>

          <router-link
            :to="item.url"
            class="ml-1 text-xs font-medium text-gray-400 hover:text-gray-700 md:ml-4 md:text-sm"
            >{{ item.name }}</router-link
          >
        </div>
      </li>
    </ol>
  </nav>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Breadcrumb",
  // props: {
  //   nameProduct: {
  //     type: Array,
  //     default: [],
  //   },
  // },
  computed: {
    ...mapState({
      info: (state) => state.investment.parameters.info,
    }),
  },
  watch: {
    info(value) {
      this.breadcrumb = [
        { name: "Investimentos", url: "/investments" },
        // { name: "Parâmetros", url: "/investments" },
        {
          name: value.investment_name,
          url: `/investments/${this.$route.params.investment_id}/edit`,
        },
      ];
      return value;
    },
  },
  data: () => ({ breadcrumb: [] }),
};
</script>
